import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import Signature from './Signature';

import {
    Typography,
    Paper,
    withStyles
} from '../node_modules/@material-ui/core';

const style = {
    root: {
        padding: '10px'
    },
    placeholder: {
        fontWeight: 'lighter'
    }
};

class SignatureComponent extends React.Component {
    constructor(props) {
        super(props);
        this.renderToString = this.renderToString.bind(this);
    }

    renderComponents(user) {
        return <Signature user={user} />;
    }

    renderToString() {
        const markup = renderToStaticMarkup(
            <Signature user={this.props.user} />
        );
        console.log(markup);
    }

    render() {
        const { classes, user } = this.props;
        if (user.name === undefined) {
            return (
                <div>
                    <Paper className={classes.root}>
                        <Typography
                            variant="headline"
                            className={classes.placeholder}
                        >
                            enter data to build your signature
                        </Typography>
                    </Paper>
                </div>
            );
        } else {
            return (
                <div>
                    <Paper className={classes.root}>
                        <Typography variant="title">
                            {user.name} here is your Signature
                        </Typography>
                        {this.renderComponents(user)}
                        <Typography variant="body1" />
                        
                    </Paper>
                </div>
            );
        }
    }
}

export default withStyles(style)(SignatureComponent);



// WEBPACK FOOTER //
// ./src/SignatureComponent.js